enum ExpenditureType {
  CAPEX = "CAPEX",
  OPEX = "OPEX",
}

type Props = {
  value: ExpenditureType | undefined;
  disabled: boolean;
  submit: (value: ExpenditureType | null) => void;
};

export type { Props };
export { ExpenditureType };
